module.exports = __webpack_public_path__ + "images/icons_v2/profile-filled-1e66467a.svg";